import {BaseAnalyticsEvent} from "../../../infrastructure/models/analytics/base-analytics-event";
import {ANALYTICS} from "../../../third-party-services/analytics/analytics-consts";
import {APP} from "../../app/consts";

export class NotificationsToggleClickEvent extends BaseAnalyticsEvent {
  source: APP.ANALYTICS.SOURCES;
  isActive: Boolean;

  constructor(params: NotificationsToggleClickEvent) {
    super('', 'click', 'notifications');

    this.isActive = params.isActive;
    this.source = params.source;
  }

  get properties() {
    const properties = super.properties;

    properties.clickType = this.isActive ? ANALYTICS.IS_NOTIFICATIONS.on : ANALYTICS.IS_NOTIFICATIONS.off;
    properties.source = this.source;

    return properties;
  }

}
